import React, { FunctionComponent, useRef, useEffect } from 'react';
import { IconColor, IconName } from 'app/common/components/controls';
import { IconButton } from 'app/common/components/controls/button/button';

import { Noun, Verb } from '@trello/analytics';
import { track } from './Analytics';

import styles from './OnboardingDialog.less';

const analyticsSource = 'onboardingDialog';
interface DialogProps {
  title: React.ReactNode;
  helpLink?: string;
  closeDialog: () => void;
  image?: HTMLImageElement;
}

export const OnboardingDialog: FunctionComponent<DialogProps> = ({
  title,
  helpLink,
  children,
  closeDialog,
  image,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  // Append pre-loaded image on mount
  useEffect(() => {
    if (ref.current && image) {
      ref.current.appendChild(image);
    }
  });

  return (
    <div ref={ref} className={styles.dialog}>
      <div className={styles.controls}>
        {helpLink && (
          <IconButton
            icon={IconName.Information}
            className={styles.icon}
            color={IconColor.Dark}
            largeIcon
            onClick={() => {
              track({
                verb: Verb.OPENS,
                noun: Noun.HELP_DOC_LINK,
                method: 'by clicking overlay icon',
                context: {
                  url: helpLink,
                },
                source: analyticsSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'atlassianOnboardingHelpDocButton',
              });
              window.open(helpLink, '_blank');
            }}
          />
        )}
        <IconButton
          icon={IconName.Close}
          className={styles.icon}
          color={IconColor.Dark}
          largeIcon
          onClick={() => {
            track({
              verb: Verb.DISMISSES,
              noun: Noun.ONBOARDING_MENU,
              method: 'by clicking dismiss button',
              source: analyticsSource,
              action: 'clicked',
              actionSubject: 'button',
              actionSubjectId: 'atlassianAccountOnboardingOverlayCloseButton',
            });
            closeDialog();
          }}
        />
      </div>
      <div className={styles.content}>
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div>{children}</div>
      </div>
    </div>
  );
};
